import React, { useEffect, ComponentProps } from 'react';
import { useAuthentication } from '../../../Login/hooks/useAuthentication';
import { ApplicationEntrySidebar } from './ApplicationEntrySidebar';
import { ApplicationEntrySaveAndExitButton } from './components/ApplicationEntrySaveAndExitButton';
import { ApplicationEntryNavigationButtons } from './components/ApplicationEntryNavigationButtons/ApplicationEntryNavigationButtons';
import { ApplicationEntryPropertyDeleteButton } from './components/ApplicationEntryPropertyDeleteButton';
import { ProgressBreadcrumb, Button } from '@apply/components';

type ProgressBreadcrumbProps = ComponentProps<typeof ProgressBreadcrumb>;
type ButtonProps = ComponentProps<typeof Button>;
export interface ApplicationEntryPanelV2Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
    sections: ProgressBreadcrumbProps[];
    currentSection: number;
    printMode?: boolean;
    saveAndExitButtonProps: ButtonProps;
    nextStepButtonProps: ButtonProps;
    deletePropertyButtonProps?: ButtonProps;
    previousStepButtonVisible?: boolean;
    previousStepButtonClick?: React.MouseEventHandler;
}

export const ApplicationEntryPanel: React.FC<ApplicationEntryPanelV2Props> = ({
    children,
    sections,
    currentSection,
    saveAndExitButtonProps,
    nextStepButtonProps,
    deletePropertyButtonProps,
    previousStepButtonVisible,
    previousStepButtonClick,
    printMode = false,
}) => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    return (
        <>
            <div className='applicationEntry-nonMobile'>
                {!printMode && (
                    <div className='applicationEntry-left'>
                        <ApplicationEntrySidebar
                            crumbs={sections}
                            currentCrumb={currentSection}
                        />
                    </div>
                )}
                <div className='applicationEntry-right'>
                    <div className='applicationEntry-appWrapper'>
                        <div className='applicationEntry-appWrapper-saveAndExitButtons'>
                            <ApplicationEntrySaveAndExitButton
                                saveAndExitButtonProps={saveAndExitButtonProps}
                                printMode={printMode}
                            />
                            {deletePropertyButtonProps && (
                            <ApplicationEntryPropertyDeleteButton
                                deletePropertyButtonProps={deletePropertyButtonProps}
                                printMode={printMode}
                            />)}
                        </div>
                        <div className='applicationEntry-appWrapper-content'>{children}</div>
                        <div className='applicationEntry-appWrapper-navigationButtons'>
                            <ApplicationEntryNavigationButtons
                                nextStepButtonProps={nextStepButtonProps}
                                previousStepButtonVisible={previousStepButtonVisible}
                                previousStepButtonClick={previousStepButtonClick}
                                printMode={printMode}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
